<script>
  import dayjs from 'dayjs'
  import relativeTime from 'dayjs/plugin/relativeTime'

  dayjs.extend(relativeTime)

  // Elapsed-time badge, e.g. "3h ago". `stale` tones the badge warning/error past thresholds
  // (used for oldest-pending-review style call-outs on moderation queues).
  let { timestamp, staleAfterHours, criticalAfterHours } = $props()

  const hoursAgo = $derived(timestamp ? dayjs().diff(dayjs(timestamp), 'hour', true) : null)

  const tone = $derived.by(() => {
    if (hoursAgo === null) return 'badge-ghost'
    if (criticalAfterHours && hoursAgo >= criticalAfterHours) return 'badge-error'
    if (staleAfterHours && hoursAgo >= staleAfterHours) return 'badge-warning'
    return 'badge-ghost'
  })
</script>

{#if timestamp}
  <span class="badge {tone}" title={dayjs(timestamp).format('MMM D, YYYY h:mm A')}>
    {dayjs(timestamp).fromNow()}
  </span>
{/if}
